import LazySizes from 'lazysizes';

LazySizes.init();
